module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/3_4aa9caf0320de05c532ed29e9dfc460c.png";